import React, 
       { useState, 
         useContext, 
         useEffect }   from 'react';
import { Card, 
         Container,
         Row,
         Col         } from 'react-bootstrap';
import ProgressBar     from 'react-bootstrap/ProgressBar';
import api             from './AxiosConfig';
import { AuthContext } from './AuthContext';

function AdminSystem() {
    const { isLoggedIn,
            isAdmin     }                     = useContext(AuthContext);
    const [systemStats,    setSystemStats]    = useState( {} );
       
    useEffect(() => {
        // Fetch status and admin options only once on mount
        async function getSystemStats() {
            try {
                if ( isLoggedIn && isAdmin ) {
                    const response = await api.get('/site/system', {withCredentials: true });
                    if (response.status === 201) {
                        setSystemStats(response.data.system);
                        //   system: { diskPercentUsed: percentUsed, diskTotal: total, diskAvailable: available, diskUsed: used, 
                        //             userTotal: u[0].userTotal,  goalTotal: g[0].goalTotal, checklistTotal: c[0].checklistTotal, progressTotal: p[0].progressTotal }
                    }
                }
            } catch (error) {
                console.log("Error " + error);
            }
        }

        getSystemStats();
    }, [isLoggedIn, isAdmin]);
       
    return (
      <Container><Row><Col xs={12} sm={12} md={6} lg={6}>
      <Card>
      <Card.Header className="card-goal-header">
        <Card.Title>
              System Data
        </Card.Title>
      </Card.Header>
      <Card.Body className="p-0" >
          <div className={"card-goal-seperator"}>Database Usage</div>
            <div>Users: {systemStats.userTotal}</div>
            <div>Goals: {systemStats.goalTotal}</div>
            <div>Checklists: {systemStats.checklistTotal}</div>
            <div>Progress Records: {systemStats.progressTotal}</div>
          <div className={"card-goal-seperator"}>Disk Usage</div>
            <div>&nbsp;</div>
            <ProgressBar>
              { systemStats.diskPercentUsed > 80 ? 
                 (<ProgressBar variant="danger"  label={ Number(systemStats.diskUsed).toFixed(2) + `GiB`} now={systemStats.diskPercentUsed} key={1} />) :
                 (<ProgressBar variant="warning" label={ Number(systemStats.diskUsed).toFixed(2) + `GiB`} now={systemStats.diskPercentUsed} key={1} />) 
              }
              <ProgressBar variant="success" label={ Number(systemStats.diskAvailable).toFixed(2) + `GiB`} now={100.0 - systemStats.diskPercentUsed} key={2} />
            </ProgressBar>
          <div className={"card-goal-seperator"}>Memory Usage</div>
            <ProgressBar>
              { systemStats.diskPercentUsed > 80 ? 
                 (<ProgressBar striped variant="danger"  label={ Number(systemStats.memoryUsed/systemStats.memoryTotal).toFixed(2) + `GiB`} now={Number(systemStats.memoryUsed/systemStats.memoryTotal) * 100.0} key={1} />) :
                 (<ProgressBar striped variant="warning" label={ Number(systemStats.memoryUsed/systemStats.memoryTotal).toFixed(2) + `GiB`} now={Number(systemStats.memoryUsed/systemStats.memoryTotal) * 100.0} key={1} />) 
              }
              <ProgressBar variant="success" label={ (systemStats.memoryFree/systemStats.memoryTotal).toFixed(2) + `GiB`} now={100.0 - (Number(systemStats.memoryUsed/systemStats.memoryTotal) * 100.0)} key={2} />
            </ProgressBar>
          <div className={"card-goal-seperator"}>CPU Usage</div>
            <div>CPU 1 Minute: {systemStats.cpuOneMin}%</div>
            <div>CPU 5 Minutes: {systemStats.cpuFiveMin}%</div>
            <div>CPU 15 Minutes: {systemStats.cpuFifteenMin}%</div>
          
        </Card.Body>
      </Card>
      </Col></Row></Container>

    );
}

export default AdminSystem;
